import React from "react";

function HeartSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill={props.bgColor ? props.bgColor : "none"}
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill={props.bg_color} rx="10"></rect>
      <path
        fill="#262626"
        d="M12.344 5.875c-.968 0-1.816.416-2.344 1.12-.528-.704-1.376-1.12-2.344-1.12A2.91 2.91 0 004.75 8.781c0 3.281 4.865 5.937 5.072 6.047a.375.375 0 00.356 0c.207-.11 5.072-2.765 5.072-6.047a2.91 2.91 0 00-2.906-2.906zM10 14.069c-.856-.499-4.5-2.771-4.5-5.288a2.16 2.16 0 012.156-2.156c.912 0 1.677.486 1.997 1.266a.375.375 0 00.694 0c.32-.782 1.085-1.266 1.997-1.266A2.159 2.159 0 0114.5 8.781c0 2.513-3.645 4.788-4.5 5.288z"
      ></path>
    </svg>
  );
}

export default HeartSvg;
